import { TOKEN } from "../constants/localstoregeConstants";

export const getAllRequiredHeaders = ({ isLoginURL }) => {
  // rbu = request base url
  // ruep = request url end point

  let headers = {};

  if (isLoginURL) {
    headers["token-id"] = 0;
  } else {
    headers["token-id"] = localStorage.getItem(TOKEN);
    headers["client-id"] = localStorage.getItem("client_id");
  }

  headers["device-type"] = process.env.REACT_APP_DEVICE_TYPE;

  return {
    ...headers,
  };
};



// WEBPACK FOOTER //
// ./src/utils/apiUtils/appUtils.js